if (!customElements.get('mcocod-footer')) {
  customElements.define('mcocod-footer', class extends HTMLElement {
    connectedCallback() {
      this.media = matchMedia('(max-width:600px)');
      this.sync = () => {
        this.querySelectorAll('.mh-ft-col').forEach(column => {
          column.open = !this.media.matches;
          const summary = column.querySelector('summary');
          if (this.media.matches) summary.removeAttribute('tabindex');
          else summary.setAttribute('tabindex', '-1');
        });
      };
      this.onClick = event => {
        if (!this.media.matches && event.target.closest('.mh-ft-col summary')) event.preventDefault();
      };
      this.onSelect = event => {
        const column = event.target.closest('.mh-ft-col');
        if (column) column.open = true;
      };
      this.sync();
      this.media.addEventListener('change', this.sync);
      this.addEventListener('click', this.onClick);
      this.addEventListener('shopify:block:select', this.onSelect);
    }

    disconnectedCallback() {
      this.media.removeEventListener('change', this.sync);
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('shopify:block:select', this.onSelect);
    }
  });
}
